(function() {
  var AngularApplication, Socket,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AngularApplication = require('resources/assets/coffee/Core/AngularApplication').AngularApplication;

  Socket = require('resources/assets/coffee/Core/Socket').Socket;

  exports.CoreApp = (function(superClass) {
    extend(CoreApp, superClass);

    function CoreApp() {
      this.initMap = bind(this.initMap, this);
      this.initAngular = bind(this.initAngular, this);
      return CoreApp.__super__.constructor.apply(this, arguments);
    }

    CoreApp.prototype.init = function() {
      var self;
      this.angular_default_route = '/';
      this.addAngularRoutes([
        {
          path: 'core::Angular/NavigationRouter'
        }, {
          path: 'core::Angular/UsernameDropdownRouter'
        }, {
          path: 'grower::Angular/MainRouter'
        }, {
          path: 'grower::Angular/AdvisorRequest/Router'
        }, {
          path: 'grower::Angular/Data/DataRouter'
        }, {
          path: 'grower::Angular/Data/PlantingRx/PlantingRxRouter'
        }, {
          path: 'grower::Angular/Fields/FieldsRouter'
        }, {
          path: 'grower::Angular/Fields/Define/DefineRouter'
        }, {
          path: 'grower::Angular/Placement/PlacementRouter'
        }, {
          path: 'grower::Angular/Profile/ProfileRouter'
        }, {
          path: 'grower::Angular/Contacts/ContactsRouter'
        }, {
          path: 'grower::Angular/Fieldprint/FieldprintRouter'
        }, {
          path: 'grower::Angular/BuyerLocation/Router'
        }, {
          path: 'portal::Angular/Account/AccountRouter'
        }, {
          path: 'portal::Angular/Zones/ZonesRouter'
        }, {
          path: 'portal::Angular/Weightings/WeightingsRouter'
        }, {
          path: 'portal::Angular/Hybrids/HybridsRouter'
        }, {
          path: 'portal::Angular/Daystoharvest/DaystoharvestRouter'
        }, {
          path: 'portal::Angular/Ratings/RatingsRouter'
        }, {
          path: 'portal::Angular/KeyFields/KeyFieldsRouter'
        }, {
          path: 'portal::Angular/KeyFieldsDefine/KeyFieldsDefineRouter'
        }, {
          path: 'portal::Angular/Contracts/ContractsRouter'
        }, {
          path: 'portal::Angular/Convert/ConvertRouter'
        }, {
          path: 'portal::Angular/Delivery/DeliveryRouter'
        }, {
          path: 'portal::Angular/Communicate/CommunicateRouter'
        }, {
          path: 'portal::Angular/Koz/KozRouter'
        }, {
          path: 'portal::Angular/QbUsers/QbUsersRouter'
        }, {
          path: 'portal::Angular/Audit/AuditRouter'
        }, {
          path: 'portal::Angular/OnFarmStorage/OnFarmStorageRouter'
        }, {
          path: 'portal::Angular/QBQ/QBQRouter'
        }, {
          path: 'portal::Angular/Customers/PortalCustomersRouter'
        }, {
          path: 'admin::Angular/Inserter/InserterRouter'
        }, {
          path: 'admin::Angular/Tools/ToolsRouter'
        }, {
          path: 'admin::Angular/Preferences/PreferencesRouter'
        }, {
          path: 'admin::Angular/Funsies/FunsiesRouter'
        }
      ]);
      this.addAngularServices(['grower::Services/TruthStripToolbar']);
      window.Socket = new Socket();
      return self = this;
    };

    CoreApp.prototype.initAngular = function() {
      var SafeLinkController, Service, UsernameDropdownController;
      CoreApp.__super__.initAngular.call(this);
      SafeLinkController = this.loadClass('grower::Angular/SafeLinkController');
      Service = this.loadClass('grower::Angular/SafeLinkService');
      this.angularApp.service('SafeLinkService', ['$http', '$rootScope', Service]);
      this.angularApp.controller('SafeLinkController', ['$scope', '$transitions', 'SafeLinkService', 'Core.Services.Session', SafeLinkController]);
      UsernameDropdownController = this.loadClass('core::Angular/UsernameDropdown/MainController');
      return this.angularApp.controller('UsernameDropdownController', ['$scope', '$transitions', '$uibModal', UsernameDropdownController]);
    };

    CoreApp.prototype.initMap = function() {
      return void 0;
    };

    return CoreApp;

  })(AngularApplication);

}).call(this);
